import React from 'react'
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts'
import {
  nameToId
} from '../mapData'

const Chart = ({ data, width, height, country }) => {
    const renderColorfulLegendText = (value, entry) => {
      const color = 'black'

      return <span style={{ color }}>{value}</span>
    }

    const renderXAxis = ({ payload, x, y }) => {
      return <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16}
          textAnchor='end'
          fontWeight={payload.value === country && 'bold'}
          textDecoration={payload.value === country && 'underline'}
          >{nameToId[payload.value]}</text>
      </g>
    }

    return (
      <ResponsiveContainer width={width} height={height}>
        <BarChart
          data={data}
          margin={{
            top: 5, right: 5, left: 5, bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' tick={renderXAxis} />
          <YAxis type='number' domain={[-1, 1]}/>
          <Tooltip />
          <Bar dataKey='polarisation' fill='#5EE6FE' />
          <Bar dataKey='resilience' fill='#224393' />
          <Legend verticalAlign='bottom' height={36} formatter={renderColorfulLegendText} />
        </BarChart>
      </ResponsiveContainer>
    )
}

export default Chart



// WEBPACK FOOTER //
// ./src/components/ToolkitComponent/components/Chart.js